import React from 'react';
import { ApLoaderDefault } from '@alixpartners/ui-components';
import { CardText, CardValue, IconWrapper, KpiCard } from './KpiList.styles.js';
export const KpiElement = ({ cardTitle, value, isLoading, step, icon }) => {
	return (
		<KpiCard data-tour={step}>
			{isLoading ? (
				<ApLoaderDefault />
			) : (
				<div style={{ display: 'flex', justifyContent: 'space-around' }}>
					<div>
						<CardText>{cardTitle}</CardText>
						<CardValue>{value}</CardValue>
					</div>
					<IconWrapper>{icon}</IconWrapper>
				</div>
			)}
		</KpiCard>
	);
};
